var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSwitchArtist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24066 6.61424C1.65117 6.93333 0.105569 7.58489 1.04694 8.40021C1.5068 8.79849 2.01895 9.08333 2.66286 9.08333L6.33714 9.08333C6.98105 9.08333 7.4932 8.79849 7.95306 8.40021C8.89443 7.58489 7.34883 6.93333 6.75934 6.61424C5.37701 5.86596 3.62299 5.86596 2.24066 6.61424Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 2.64394C6.375 3.68993 5.53553 4.53788 4.5 4.53788C3.46447 4.53788 2.625 3.68993 2.625 2.64394C2.625 1.59795 3.46447 0.75 4.5 0.75C5.53553 0.75 6.375 1.59795 6.375 2.64394Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41602 11.5835C2.41602 14.3478 4.65173 16.5835 7.41602 16.5835L6.70173 15.1549",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 6.5835C15.75 3.81921 13.5143 1.5835 10.75 1.5835L11.4643 3.01207",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4067 14.9477C10.8172 15.2668 9.27158 15.9184 10.213 16.7337C10.6728 17.132 11.185 17.4168 11.8289 17.4168L15.5032 17.4168C16.1471 17.4168 16.6592 17.132 17.1191 16.7337C18.0604 15.9184 16.5148 15.2668 15.9254 14.9477C14.543 14.1995 12.789 14.1995 11.4067 14.9477Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.541 10.9774C15.541 12.0234 14.7016 12.8714 13.666 12.8714C12.6305 12.8714 11.791 12.0234 11.791 10.9774C11.791 9.93144 12.6305 9.0835 13.666 9.0835C14.7016 9.0835 15.541 9.93144 15.541 10.9774Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitchArtist);
export default __webpack_public_path__ + "static/media/icon-switch-artist.cc96c7c8ceda724090144d2ac0668c7e.svg";
export { ForwardRef as ReactComponent };